export const SALES_RETURN_PERMISSION = Object.freeze({
  VIEW: 'SL_RETURNREQUEST_VIEW',
  ADD: 'SL_RETURNREQUEST_ADD',
  EDIT: 'SL_RETURNREQUEST_EDIT',
  INTAKE: 'SL_RETURNREQUEST_INTAKE',
  INSPECT: 'SL_RETURNREQUEST_INSPECT',
  APPROVE: 'SL_RETURNREQUEST_APPROVE',
  ACCOUNTING: 'SL_RETURNREQUEST_ACCOUNTING_REVIEW',
  POST: 'SL_RETURNREQUEST_POST',
  SETTLE: 'SL_RETURNREQUEST_SETTLE',
  CLOSE: 'SL_RETURNREQUEST_CLOSE',
  OVERRIDE: 'SL_RETURNREQUEST_OVERRIDE',
  CONFIG_VIEW: 'SL_RETURNREQUEST_CONFIG_VIEW',
  CONFIG_EDIT: 'SL_RETURNREQUEST_CONFIG_EDIT',
});

export const SALES_RETURN_WORKFLOW_READ_PERMISSIONS = Object.freeze([
  SALES_RETURN_PERMISSION.VIEW,
  SALES_RETURN_PERMISSION.INTAKE,
  SALES_RETURN_PERMISSION.INSPECT,
  SALES_RETURN_PERMISSION.APPROVE,
  SALES_RETURN_PERMISSION.ACCOUNTING,
  SALES_RETURN_PERMISSION.POST,
  SALES_RETURN_PERMISSION.SETTLE,
  SALES_RETURN_PERMISSION.CLOSE,
]);
